import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';
import { IdSchema } from '../../../resource-base/baseSchemas';

export enum ProcessAreaMethodAssociationPropertyValidation {
    METHOD = 'METHOD',
}

export const ProcessAreaMethodAssociationResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z
        .literal(ResourceType.PROCESS_AREA_METHOD_ASSOCIATION)
        .default(ResourceType.PROCESS_AREA_METHOD_ASSOCIATION),
    method: IdSchema,
});
export const ProcessAreaMethodAssociationMutationResourceSchema = getMutationSchema(
    ProcessAreaMethodAssociationResourceSchema
);

export type ProcessAreaMethodAssociationResource = z.infer<typeof ProcessAreaMethodAssociationResourceSchema>;

export const defaultProcessAreaMethodAssociationResource: ProcessAreaMethodAssociationResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.PROCESS_AREA_METHOD_ASSOCIATION,
    method: '',
};

export function useProcessAreaMethodAssociationActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/process-area-method-association',
            ResourceType.PROCESS_AREA_METHOD_ASSOCIATION,
            ProcessAreaMethodAssociationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-area-method-association',
            ResourceType.PROCESS_AREA_METHOD_ASSOCIATION,
            ProcessAreaMethodAssociationResourceSchema
        ),
    };
}
